import { Phrase } from 'components/Phrase';

import {
  CalendarImage,
  Container,
  Description,
  Header,
  Logo,
  SubHeader,
} from './styles';

export const CarouselItemScheduleMaintenanceExpiredTop = () => {
  return (
    <>
      <Container>
        <Header>
          <Phrase id="SCHEDULE_MAINTENANCE.LINK_EXPIRED.HEADER" />
        </Header>
        <CalendarImage />
        <SubHeader>
          <Phrase id="SCHEDULE_MAINTENANCE.LINK_EXPIRED.SUBHEAD" />
        </SubHeader>
        <Description>
          <Phrase id="SCHEDULE_MAINTENANCE.LINK_EXPIRED.INSTRUCTION" />
        </Description>
        <hr />
        <Header>
          <Phrase id="PHONE_STYLIZED" />
        </Header>
        <Logo />
      </Container>
    </>
  );
};
